import type { RootState } from 'store/store';

export const loadState = () => {
  // return { activeTournamentId: null };

  try {
    const activeTournamentId = localStorage.getItem('imgame:activeTournamentId');
    if (activeTournamentId) {
      return {
        activeTournamentId: Number(activeTournamentId),
      };
    }

    return { activeTournamentId: null };
  } catch (err) {
    return { activeTournamentId: null };
  }
};

export const saveState = (state: RootState) => {
  try {
    const activeTournamentId = state.auth.activeTournamentId;

    if (!activeTournamentId) {
      localStorage.removeItem('imgame:activeTournamentId');
    }

    localStorage.setItem('imgame:activeTournamentId', String(activeTournamentId));
  } catch (err) {}
};
